var RCDPW = {
    /**
     * Create objects on global RCDPW object.
     * @param {String} namespace - Namespace, i.e. 'RCDPW.Angular'
     */
    ns: function (namespace) {
        var head;
        var nsString = namespace.split(".");
        head = RCDPW;

        for(var i = 0; i < nsString.length; i++) {
            var nodeName = nsString[i];
            if (window[nodeName] === head) {
                continue;
            }
            head[nodeName] = head[nodeName] || {};
            head = head[nodeName];
        }

        return head;
    },

    module: function (module, extending) {
        return this.include(module, extending);
    },

    /**
     * Include #{source} into target.
     *
     * @param {Object|String} target - Target Object.
     * @param {Object|Function} source - Include source.
     * @returns {Object}
     */
    include: function (target, source) {
        source = this.isFunction(source) ? source.call(null) : source;
        target = this.isString(target) ? this.ns(target) : target;

        if (source && this.isObject(source)) {
            for (var p in source) {
                if (source.hasOwnProperty(p)) {
                    target[p] = source[p];
                }
            }
        }

        return target;
    },

    clone: function (source) {
        var clone = {};

        if (source && this.isObject(source)) {
            for (var p in source) {
                if (source.hasOwnProperty(p)) {
                    clone[p] = source[p];
                }
            }
        }

        return clone;
    },

    isObject: function (v) {
        return v && this.type(v) === 'object';
    },

    isString: function(v) {
        return this.type(v) === 'string';
    },

    isFunction: function (v) {
        return this.type(v) === 'function';
    },

    type: function (v) {
        var toString = Object.prototype.toString;
        var typePattern = /\[object ([a-zA-Z]+)]/;
        var result = typePattern.exec(toString.call(v));
        return result ? result[1].toLowerCase() : void(0);
    }
};
